import { API_BASE_URL } from './api';
import { getAccessToken } from './auth';

export interface AccessSummary {
  unlimited: boolean;
  source: 'free' | 'subscription' | 'vip';
  vipSince: string | null;
  checkoutAvailable: boolean;
  canManageSubscription: boolean;
  plan: { name: string; priceUsd: number; interval: 'month' };
  subscription: { status: string; currentPeriodEnd: string | null; cancelAtPeriodEnd: boolean; scheduledChangeAt: string | null } | null;
}

export type BillingConfig = { configured: boolean; environment: 'sandbox' | 'production'; clientToken: string };

export class BillingRequestError extends Error {
  constructor(public status: number, message: string) { super(message); }
}

export async function billingRequest<T>(path: string, method = 'GET'): Promise<T> {
  const token = await getAccessToken();
  if (!token) throw new BillingRequestError(401, 'Sign in to your account to continue.');
  const response = await fetch(`${API_BASE_URL}${path}`, { method, cache: 'no-store', headers: { Authorization: `Bearer ${token}` } });
  if (!response.ok) {
    const payload = await response.json().catch(() => ({}));
    throw new BillingRequestError(response.status, payload.error || 'Unable to check your subscription. Please try again.');
  }
  return response.json();
}

export async function loadBillingConfig(): Promise<BillingConfig> {
  const response = await fetch(`${API_BASE_URL}/billing/config`, { cache: 'no-store' });
  if (!response.ok) throw new Error('Payments are temporarily unavailable.');
  return response.json();
}
